export const DRAG_STATUS = Object.freeze({
  START: "start",
  STOP: "stop",
  ENTER: "enter",
  LEAVE: "leave",
});
